import * as React from "react";
import * as ReactDOM from "react-dom";
import {WebChat} from "./WebChat";
import {BotTabs} from "./BotPage";
import {BotService} from "../../Generated/RestClient";
import {BotEditor, BotEditorProps} from "./BotEditor";
import {BotSettingsTabProps} from "./BotSettingsTab";
import {BotCodeSetupProps, BotCodeSetup} from "./BotCodeSetup";
import {AnalyticsDashboard} from "./AnalyticsDashboard";
import {BotChannelConfig, ChannelConfigInterface} from "./BotChannelConfig";
import {BotChannels} from "./BotChannels";
import { BotTypes, BotUtils } from "../../Utils/BotUtils";
import {BotCodeEditor, BotCodeEditorProps} from "./BotCodeEditor";
import {BotAppSettings} from "./BotAppSettings";
import {combineClassNames} from "../../Utils/ReactUtils";
import { Environment } from "../../../../Intercom.ReactUI/Utils/Environment";
import { FooterControl, resourceStrings } from "../../../../Intercom.ReactUI/Views/index";

export interface BotPageBodyProps extends React.Props<BotPageBody> {
    bot: BotService;
    botSettingsTabProps: BotSettingsTabProps;
    botEditorProps: BotEditorProps;
    botCodeEditorProps: BotCodeEditorProps;
    botCodeSetupProps: BotCodeSetupProps;
    authoringDirty: boolean;
    authoringError: boolean;
    selectedTab: number;
    renderWebChat: boolean;
    showWebChat: boolean;
    showWebChatPending: boolean;
    channel?: string;
    channelConfigClickHandler: (toChannel: string) => void;
    channelConfigInterface: ChannelConfigInterface;
    tabClickHandler: (tab: BotTabs) => void;
    onSetBotAppSettings(botAppSettings: BotAppSettings);
    azureToken: string;
    canWriteToBot: boolean;
}

export class BotPageBody extends React.Component<BotPageBodyProps, {}> {
    private botSettingsPage: BotEditor;
    private authoringSurfaceHost: JQuery;

    public componentWillMount() {
        this.authoringSurfaceHost = $('<iframe id="authoringSurfaceHost" style="display: none; position: absolute; top: 0; left: 0; width: 0; height: 0; margin: 0; padding: 0; border:0; overflow-y: hidden;"></iframe>');
        $("body").append(this.authoringSurfaceHost);
    }

    public componentWillUnmount() {
        if (this.authoringSurfaceHost && this.authoringSurfaceHost.length) {
            this.authoringSurfaceHost.remove();
            this.authoringSurfaceHost = null;
        }
    }

    private renderBuildTab(botType: BotTypes): JSX.Element {
        switch (botType) {
            case BotTypes.ABSv1:
                return (<BotCodeEditor
                            {...this.props.botCodeEditorProps}
                            ref={x => this.props.botCodeEditorProps.onSetCodeEditor(x) }/>);
            case BotTypes.ABSCode:
                return (
                    <BotCodeSetup {...this.props.botCodeSetupProps}
                        ref={x => this.props.botCodeSetupProps.setCodeSetup(x)}/>
                );
        }
        return null;
    }

    private renderActivePage(): JSX.Element {
        switch (this.props.selectedTab) {
            case BotTabs.Build:
                const botType = BotUtils.getBotType(this.props.bot);
                return this.renderBuildTab(botType);
            case BotTabs.Analytics:
                return (<AnalyticsDashboard
                    showWebChat= { this.props.showWebChat }
                    bot={ this.props.bot }
                    tabClickHandler={ this.props.tabClickHandler } />);
            case BotTabs.Channels:
                if (this.props.channel) {
                    return (<BotChannelConfig
                        currentBotId={ this.props.bot.Id }
                        channel={ this.props.channel }
                        channelConfigInterface={ this.props.channelConfigInterface }
                        azureToken={ this.props.azureToken }/>
                    );
                }
                return (<BotChannels
                    bot={ this.props.bot }
                    userCanWriteBot={ this.props.canWriteToBot }
                    channelDataHandlers={ this.props.botSettingsTabProps.channelDataHandlers }
                    channelConfigClickHandler={ this.props.channelConfigClickHandler }/>
                );
            case BotTabs.Settings:
                return (<BotEditor
                            onSetBotAppSettings={this.props.onSetBotAppSettings}
                            {...this.props.botEditorProps}
                            ref={x => this.props.botEditorProps.onSetEditor(x) }/>);
            case BotTabs.Develop:
                return (<BotCodeEditor
                            {...this.props.botCodeEditorProps}
                            ref={x => this.props.botCodeEditorProps.onSetCodeEditor(x) }/>);
            default:
                // invalid tab
                break;
        }
    }

    private getAdditionalBodyLeftCssForActivePage(): string {
        switch (this.props.selectedTab) {
            case BotTabs.Analytics:
                return "noscroll";
            default:
                return null;
        }
    }

    private getWithWebChatCss(): string {
            return (this.props.showWebChat) ? 'with-webchat' : '';
    }

    private renderWebChat(): JSX.Element {
        return this.props.showWebChatPending && this.props.showWebChat ? <div className="bot-page-webchat pending">{resourceStrings.loadingBotWebChat}</div> :
            <WebChat className={combineClassNames("bot-page-webchat", this.getWithWebChatCss())}
                     bot={this.props.bot}
                     authoringDirty={this.props.authoringDirty}
                     authoringError={this.props.authoringError}
            />;
    }

    public render(): JSX.Element {
        const inAzureClass = Environment.isInBotFrameworkAzureExtension ? "in-azure" : "";
        const webchatRegion = this.props.renderWebChat ? (
            <div className={combineClassNames("bot-page-body-right", this.getWithWebChatCss())}>
                {this.renderWebChat()}
            </div>
        ) : null;

        return(
            <div className={combineClassNames("bot-page-body", inAzureClass)}>
                <div className={combineClassNames("bot-page-body-left", this.getAdditionalBodyLeftCssForActivePage(), this.getWithWebChatCss())}>
                    {this.renderActivePage()}
                    <FooterControl scrollingClass="bot-page-body" />
                </div>
                {webchatRegion}
            </div>
        );
   }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotPageBody.tsx